/* eslint-disable radix */
import React from 'react';
import jwt_decode from 'jwt-decode';

import {
  getUsuarioLocalStorage,
  getTokenLocalStorage,
} from './localStorage.util';

export  function verificaLogin(intl) {

  function getTranslate(key) {
	  return intl.formatMessage({ id: key });
	}
  
  return new Promise((resolve) => {
    const CryptoJS = require('crypto-js');
    const usuario = getUsuarioLocalStorage();
    const token = getTokenLocalStorage();
    const key = token && token.replace('bearer ', '');
    const decoded = key && jwt_decode(key);

    let mensagem = '';
    if (
      key === null ||
      key === undefined ||
      usuario === null ||
      usuario === undefined
    ) {
      resolve(logoff(mensagem));
    }

    if (
      usuario.usuarioId !== parseInt(decoded.sub)
    ) {
      mensagem = getTranslate("message.userNotCheck");
      resolve(logoff(mensagem));
    }

    const exp = decoded.exp;
    const agora = new Date().getTime();

    if (exp < agora / 1000) {
      mensagem = getTranslate("message.expired");
      resolve(logoff(mensagem));
    }

    const acessos = usuario.role;
    if (acessos === null || acessos === undefined) {
      mensagem = getTranslate("message.notPermission");
      resolve(logoff(mensagem));
    }

    try {
      const transithmac = acessos.substring(0, 64);
      const transitencrypted = acessos.substring(64);
      const decryptedhmac = CryptoJS.HmacSHA256(
        transitencrypted,
        CryptoJS.SHA256(decoded.jti)
      ).toString();
      if (
        transithmac === null ||
        transithmac === undefined ||
        transithmac !== decryptedhmac
      ) {
        mensagem = getTranslate("message.permissionNot");
        resolve(logoff(mensagem));
      }
    } catch (error) {
      mensagem = getTranslate("message.permissionNot");
      resolve(logoff(mensagem));
    }

   resolve();
  });
}

function logoff(mensagem) {
  const token = btoa(mensagem);
  localStorage.clear();
  window.location.replace(`/login/${token}`);
}



// WEBPACK FOOTER //
// ./src/acessosLogin.js